<template>
    <component
            :is="elementNameForType"
            :registrationData="registrationData"
    ></component>
</template>

<script>
    import ElementFactory from "../../components/pagesbuilder/elements/ElementFactory";
    import PreviewButtonElement from "./PreviewButtonElement";
    import PreviewButtonWrapperElement from "./PreviewButtonWrapperElement";
    import PreviewColumnElement from "./PreviewColumnElement";
    import PreviewColumnWrapperElement from "./PreviewColumnWrapperElement";
    import PreviewEmbedElement from "./PreviewEmbedElement";
    import PreviewFramedImageElement from "./PreviewFramedImageElement";
    import PreviewHorizontalLineElement from "./PreviewHorizontalLineElement";
    import PreviewHorizontalLineWrapperElement from "./PreviewHorizontalLineWrapperElement";
    import PreviewIconElement from "./PreviewIconElement";
    import PreviewHtmlElement from "./PreviewHtmlElement";
    import PreviewImageElement from "./PreviewImageElement";
    import PreviewInputElement from "./PreviewInputElement";
    import PreviewListItemElement from "./PreviewListItemElement";
    import PreviewListWrapperElement from "./PreviewListWrapperElement";
    import PreviewLeadFormElement from "./PreviewLeadFormElement";
    import PreviewLeadFormWrapperElement from "./PreviewLeadFormWrapperElement";
    import PreviewScreenElement from "./PreviewScreenElement";
    import PreviewSocialShareButtonElement from "./PreviewSocialShareButtonElement";
    import PreviewTextElement from "./PreviewTextElement";
    import PreviewVerticalDistanceElement from "./PreviewVerticalDistanceElement";
    import PreviewContactFormElement from "./PreviewContactFormElement";
    import PreviewContactFormWrapperElement from "./PreviewContactFormWrapperElement";
    import PreviewAffiliatesRegistrationElement from "./PreviewAffiliatesRegistrationElement";
    import PreviewAffiliatesButtonElement from "./PreviewAffiliatesButtonElement";
    import PreviewContextWrapperElement  from "./PreviewContextWrapperElement";
    import PreviewPaymentManagerElement  from "./PreviewPaymentManagerElement";
    import PreviewSocialLinksWrapperElement from "./PreviewSocialLinksWrapperElement";
    import PreviewMediaGalleryElement from "./PreviewMediaGalleryElement";
    import PreviewFaqElement from "./PreviewFaqElement";
    import PreviewSpacerElement from "./PreviewSpacerElement";
    import PreviewLottieAnimationElement from "./PreviewLottieAnimationElement";

    export default {
        name: "PreviewElementFactory",
        mixins: [
            ElementFactory
        ],
        data () {
            return {
                envNamePrefix: "Preview"
            }
        },
        components: {
            PreviewButtonElement,
            PreviewButtonWrapperElement,
            PreviewContextWrapperElement ,
            PreviewContactFormElement,
            PreviewContactFormWrapperElement,
            PreviewColumnElement,
            PreviewColumnWrapperElement,
            PreviewEmbedElement,
            PreviewFramedImageElement,
            PreviewHorizontalLineElement,
            PreviewHorizontalLineWrapperElement,
            PreviewHtmlElement,
            PreviewIconElement,
            PreviewImageElement,
            PreviewInputElement,
            PreviewLeadFormElement,
            PreviewLeadFormWrapperElement,
            PreviewListItemElement,
            PreviewListWrapperElement,
            PreviewScreenElement,
            PreviewSocialShareButtonElement,
            PreviewTextElement,
            PreviewVerticalDistanceElement,
            PreviewAffiliatesRegistrationElement,
            PreviewAffiliatesButtonElement,
            PreviewPaymentManagerElement,
            PreviewSocialLinksWrapperElement,
            PreviewMediaGalleryElement,
            PreviewFaqElement,
            PreviewSpacerElement,
            PreviewLottieAnimationElement
        }
    }
</script>

